import {Injectable} from "@angular/core";
import {Response} from "@angular/http";
import {Observable} from "rxjs";
import { map } from "rxjs/operators";
import {Group} from "./group.model";
import {HttpClient} from "../../httpclient";
import {Authority} from "./group-detail/authority.model";



@Injectable()
export class GroupsService {

  constructor(private httpClient: HttpClient) {}

  private basePath = '/uaa-service/';

  getAllGroups(): Observable<Group[]> {
    return this.httpClient.get(this.basePath + 'groups').pipe(map(this.extractData));
  }
    
  getAllAuthorities(): Observable<Authority[]> {
    return this.httpClient.get(this.basePath + 'authorities').pipe(map(this.extractData));
  }
    
  getGroup(pGroupId:number): Observable<Group> {
    return this.httpClient.get(this.basePath + 'groups/'+pGroupId).pipe(map(this.extractData));
  }
    
  save(pGroup:Group):Observable<Response>{
        return this.httpClient.post(this.basePath + 'groups',pGroup);
  }
    
  deleteGroup(groupId : number):Observable<Response>{
      return this.httpClient.delete(this.basePath + 'groups/'+groupId);    
  }
    
  private extractData(res: Response) {
    let body = res.json();
    return body.response;
  }
}

